import { DriverCreate, DriverQueryParams, DriversListItem } from 'bus/driverTransport/types';

import $axios from '../utils/axios-instance';

export default class DriverTransportApi {
  async getDriverTransportConfigurations({ transportId }: DriverQueryParams) {
    return await $axios
      .get<DriversListItem[]>(`/v1/DriverTransport/${transportId}/driverConfigurations`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getDriverTransport({ transportId }: DriverQueryParams) {
    return await $axios
      .get<DriversListItem[]>(`/v1/DriverTransport/${transportId}/drivers`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createDriverTransport({ transportId, driverId }: DriverCreate) {
    return await $axios
      .post(`/v1/DriverTransport/${transportId}`, { driverId })
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteDriverTransport({ transportId, driverId }: DriverCreate) {
    return await $axios
      .delete(`/v1/DriverTransport/${transportId}/${driverId}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
